import React, {ReactNode} from 'react';
import classes from './CustomCardContainer.module.scss';
import clsx from 'clsx';

interface CustomCardContainerProps {
    children: ReactNode;
    className?: string;
}

const CustomCardContainer: React.FC<CustomCardContainerProps> = ({children, className}) => {
    return (
        <div className={clsx(classes.container, className)}>
            {children}
        </div>
    );
};

export default CustomCardContainer;
